// ===========================================================================
// Module C — Medication Adherence Manager
// Constantes y enums del módulo.
// ===========================================================================

/** Locations disponibles en los dumps de DataDashCareManager. */
export const LOCATIONS = [
  { key: "fort_myers", label: "Fort Myers" },
  { key: "fort_pierce", label: "Fort Pierce" },
  { key: "hialeah", label: "Hialeah" },
  { key: "immokalee", label: "Immokalee" },
  { key: "lake_worth", label: "Lake Worth" },
  { key: "lehigh_acres", label: "Lehigh Acres" },
  { key: "lehigh_acres_5705", label: "Lehigh Acres 5705" },
  { key: "naples", label: "Naples" },
  { key: "naples_5262", label: "Naples 5262" },
  { key: "port_st_lucie", label: "Port St. Lucie" },
];

export const DEFAULT_LOCATION = "fort_myers";

/** Umbral PDC de Star/HEDIS. */
export const PDC_THRESHOLD = 80;

/** Clases terapéuticas medidas (Star/HEDIS PDC measures). */
export const THERAPEUTIC_CLASSES = ["Diabetes", "Hypertension (RASA)", "Statins"];

/** Flags de adherencia mostrados en cola y detalle. */
export const ADHERENCE_FLAGS = {
  BELOW_PDC: { label: "PDC below 80%", tone: "crit" },
  REFILL_GAP: { label: "Refill gap", tone: "warn" },
  NO_RECENT_LABS: { label: "No recent labs", tone: "warn" },
  HIGH_PILL_BURDEN: { label: "High pill burden (8+)", tone: "info" },
  OVERDUE_VISIT: { label: "Overdue visit", tone: "warn" },
};

/** Barreras de adherencia típicas (revisión de barreras en outreach). */
export const ADHERENCE_BARRIERS = [
  "Cost / copay concerns",
  "Side effects reported",
  "Complex regimen — needs med sync",
  "Transportation to pharmacy",
  "Health literacy / instructions unclear",
  "No barrier identified yet",
];

export function pdcTone(pdc) {
  if (pdc >= PDC_THRESHOLD) return "ok";
  if (pdc >= 65) return "warn";
  return "crit";
}
